import React, { useEffect, useState } from 'react';
import columns from '../../../columns/tickets.jsx';
import { Form, Input, Select } from 'antd';
import { useNavigate } from 'react-router-dom';
import ModalComponent from '../../../components/modals/ModalComponent.jsx';
import TableWithSkeleton from '../../../components/table/TableWithSkeleton.jsx';
import Pagination from '../../../components/pagination/Pagination.jsx';
import LoadableButton from '../../../components/buttons/LoadableButton.jsx';
import { GenerateTicketApi, GetAllTicketApi, GetTicketPriorityApi, GetTicketQueryTypeApi } from '../../../api/request/support.js';
import moment from 'moment';
import ReactPlayer from 'react-player'
import toast from 'react-hot-toast';
import Eye from '../../../assets/Eye.jsx';
import { GetAllTutorialsApi } from '../../../api/request/tutorials.js';
const { TextArea } = Input;

export default function Support() {

  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecord, setTotalRecord] = useState(0);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isOpenModalVideo, setIsOpenModalVideo] = useState(false);
  const [isOpenModaldetails, setIsOpenModaldetails] = useState(false);
  const [tutorials, setTutorials] = useState();
  const [isAddTicketLoading, setIsAddTicketLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [queryOptions, setQueryOptions] = useState([]);
  const [priorityOptions, setPriorityOptions] = useState([]);
  const [data, setData] = useState([]);
  const [tutorialsdetails, setTutorialsdetails] = useState({});
  const [initialValues, setInitialValues] = useState({ title: '', ticketQueryId: null, description: '', priority: null });
  const [sorter, setSorter] = useState({ SortBy: 'openDate', SortOrder: '' });

  const handleTableChange = (sorter) => {
    if (sorter?.order) {
      setSorter({ SortBy: sorter?.field, SortOrder: sorter?.order });
    } else {
      setSorter({ SortBy: 'openDate', SortOrder: '' });
    }
  };

  const getColor = (priority) => {
    switch (priority) {
      case 'High':
        return '#ef6464';
      case 'Normal':
        return '#e7c553';
      case 'Low':
        return '#2d9b63';
    }
  }

  const getAllTutorials = async () => {
    try {
      setIsLoading(true);
      let params = {
        tutorialType: 9,
        SortBy : "CreatedDate"
      }
      const { data } = await GetAllTutorialsApi(new URLSearchParams(params).toString());
      if (data?.success) {
        setTutorials(data?.data);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  const getAllTickets = async () => {
    try {
      setIsLoading(true);
      let params = {
        PageNumber: page,
        PageSize: pageSize,
        ...sorter
      }
      const { data } = await GetAllTicketApi(new URLSearchParams(params).toString());
      if (data?.success) {
        setData(
          data?.data?.map((item) => {
            return {
              ...item,
              name: `${item?.firstName} ${item?.lastName}`,
              createdAt: item?.openDate ? moment(item?.openDate).format('DD-MM-YYYY LT') : null,
              priority: (<p className='uppercase font-bold text-sm' style={{ color: getColor(item?.priority) }}>{item?.priority}</p>),
              status: (item?.status == 'Open' ? (<p className='uppercase font-bold text-[#2d9b63] text-sm'>{item?.status}</p>) : (<p className='uppercase font-bold text-[#ef6464] text-sm'>{item?.status}</p>)),
              details: (<div className='cursor-pointer ' onClick={() => navigate(`/view_ticket/${item?.ticketId}`)} src='/assets/icons/eye.svg' alt='icon' ><Eye /></div>),
            };
          })
        );
        setTotalRecord(data?.totalRecords);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getAllTickets();
  }, [page, pageSize, sorter]);

  useEffect(() => {
    getAllTutorials()
  }, []);

  useEffect(() => {
    form.resetFields();
  }, [isOpenModal])

  const handleSubmit = async (value) => {
    try {
      setIsAddTicketLoading(true);
      // 1 - User
      const { data } = await GenerateTicketApi({ userType: 1, ...value });
      if (data?.success) {
        toast.success(data?.message);
        form.resetFields();
        getAllTickets();
        setIsOpenModal(false);
      }
      setIsAddTicketLoading(false);
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
      setIsAddTicketLoading(false);
    }
  }

  const getTicketQueryType = async () => {
    try {
      const { data } = await GetTicketQueryTypeApi();
      if (data?.success) {
        setQueryOptions(data?.data?.map((item) => ({ ...item, value: item?.id, label: item?.name })));
      }
    } catch (error) { }
  }

  const getTicketPriority = async () => {
    try {
      const { data } = await GetTicketPriorityApi();
      if (data?.success) {
        setPriorityOptions(data?.data?.map((item) => ({ value: item?.value, label: item?.name })));
      }
    } catch (error) { }
  }

  const addTutorialsModalHandler = (Item) => {
    setIsOpenModaldetails(true);
    setTutorialsdetails(Item)
  }

  const addTicketModalHandler = () => {
    setIsOpenModal(true);
    getTicketQueryType();
    getTicketPriority();
  }

  return (
    <div>
      <div className='pt-4 w-full'>
        <div className='flex justify-end items-center px-4 lg:px-6 pb-4 border-b  border-light'>
          <div className='flex'>
            <div className='flex items-center mr-3' onClick={() => setIsOpenModalVideo(true)}>
              <button className=' text-sm text-white font-bold pr-9 pl-5 py-2  themeHover duration-500 bg-primary from-teal-500 to-teal-600 rounded-full p-1 shadow-lg' >Video Tutorial</button>
              <div className={`flex justify-center items-center ${'bg-secondary'} w-[43px] h-[43px] rounded-[50%] ml-[-28px]`}>
                <img src='/assets/icons/Group.svg' width={16} className='ml-[1px]' alt='icon' />
              </div>
            </div>
            <button className='bg-primary text-sm text-white font-medium uppercase px-6 py-2 rounded-lg themeHover duration-500' onClick={addTicketModalHandler}>Create Ticket</button>
          </div>
        </div>
        <div className='border border-gray-200 rounded-xl overflow-hidden bg-white my-6'>
          <TableWithSkeleton columns={columns} data={data} loading={isLoading} onChange={handleTableChange} />
          <Pagination total={totalRecord} page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />
        </div>
      </div>
      <ModalComponent isOpen={isOpenModal} setIsOpen={setIsOpenModal} title='Create Ticket' width={650}>
        <Form className='w-full' autoComplete="off" form={form} initialValues={initialValues} onFinish={handleSubmit}>
          <div className='input-white'>
            <label className='text-base text-[#2F2B3DCC] font-medium'>Title</label>
            <Form.Item name="title" rules={[{ required: true, message: 'Please enter ticket title.' }]}>
              <Input placeholder="Title" className="mt-1 w-full ps-4 py-2" />
            </Form.Item>
          </div>
          <div className='input-white mt-4'>
            <label className='text-base text-[#2F2B3DCC] font-medium'>Description</label>
            <Form.Item name="description" rules={[{ required: true, message: 'Please enter ticket description.' }]}>
              <TextArea placeholder="Description" autoSize={{ minRows: 3, maxRows: 5 }} />
            </Form.Item>
          </div>
          <div className='ant-select-selector-white mt-4'>
            <label className='text-base text-[#2F2B3DCC] font-medium'>Query Type</label>
            <Form.Item name="ticketQueryId" rules={[{ required: true, message: 'Please select a query type.' }]}>
              <Select placeholder='Select query type' className='w-full mt-1' options={queryOptions} />
            </Form.Item>
          </div>
          <div className='ant-select-selector-white mt-4'>
            <label className='text-base text-[#2F2B3DCC] font-medium'>Priority Type</label>
            <Form.Item name="priority" rules={[{ required: true, message: 'Please select a priority.' }]}>
              <Select placeholder='Select priority' className='w-full mt-1' options={priorityOptions} />
            </Form.Item>
          </div>
          <div className='mt-6 flex justify-end'>
            <LoadableButton
              className='bg-primary text-sm text-white font-medium uppercase px-8 py-2 rounded-lg themeHover duration-500'
              disabled={isAddTicketLoading}
              type="Submit"
              lable='Save'  
              isLoading={isAddTicketLoading}
              loadingLable='Adding ticket...'
            />
          </div>
        </Form>
      </ModalComponent>

      <ModalComponent isOpen={isOpenModalVideo} setIsOpen={setIsOpenModalVideo} title='Tutorial' width={1000}>
        {tutorials && tutorials.length > 0 ? (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-5 mt-6">
            {tutorials?.map((item, index) => (
              <div
                key={index}
                className="shadow-lg cursor-pointer rounded-t-2xl overflow-hidden"
                onClick={() => addTutorialsModalHandler(item)}
              >
                <div className="relative pb-[56.25%] h-0">
                  {item.youtubeUrl ? (
                    <ReactPlayer
                      url={item.youtubeUrl}
                      className="absolute top-0 left-0 w-full h-full"
                      width="100%"
                      height="100%"
                      controls
                    />
                  ) : item.videoUrl ? (
                    <ReactPlayer
                      url={item.videoUrl}
                      className="absolute top-0 left-0 w-full h-full"
                      width="100%"
                      height="100%"
                      controls
                    />
                  ) : (
                    <p>Video not available</p>
                  )}
                </div>
                <div className="text-center p-4">
                  <p className="text-lg font-semibold line-limit-1">{tutorials?.title}</p>
                  <p className="text-[#7A7A7A] text-sm line-limit-2 mt-2">{tutorials?.description}</p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className='text-center'>
            <p className='text-lg font-semibold'>Video not available</p>
          </div>
        )}
      </ModalComponent>

      <ModalComponent isOpen={isOpenModaldetails} setIsOpen={setIsOpenModaldetails} title='Tutorial' width={800}>
        <div className="relative pb-[56.25%] h-0">

          {tutorialsdetails.youtubeUrl ? (
            <ReactPlayer
              url={tutorialsdetails.youtubeUrl}
              className="absolute top-0 left-0 w-full h-full"
              width="100%"
              height="100%"
              controls
            />
          ) : tutorialsdetails.videoUrl ? (
            <ReactPlayer
              url={tutorialsdetails.videoUrl}
              className="absolute top-0 left-0 w-full h-full"
              width="100%"
              height="100%"
              controls
            />
          ) : (
            <p>Video not available</p>
          )}

        </div>
        <div className="text-center p-4">
          <p className="text-lg font-semibold line-limit-1">{tutorialsdetails?.title}</p>
          <p className="text-[#7A7A7A] text-sm line-limit-2 mt-2">{tutorialsdetails?.description}</p>
        </div>
      </ModalComponent>
    </div>
  )
}
